import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle, ArrowRight, FileText, Zap } from 'lucide-react';

function SubscriptionSuccess() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get('session_id');

    return (
        <div className="min-h-screen bg-slate-950 text-slate-200 flex items-center justify-center p-4">
            <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
                className="max-w-2xl w-full"
            >
                <div className="bg-slate-900/50 border border-slate-800 rounded-3xl p-12 text-center backdrop-blur-md">
                    {/* Success Icon */}
                    <div className="w-20 h-20 bg-green-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
                        <CheckCircle className="w-12 h-12 text-green-400" />
                    </div>

                    {/* Title */}
                    <h1 className="text-4xl font-black text-white mb-4">
                        Welcome Aboard! 🎉
                    </h1>

                    <p className="text-lg text-slate-400 mb-8">
                        Your subscription has been activated successfully. You now have access to all features of your plan.
                    </p>

                    {/* Session ID */}
                    {sessionId && (
                        <div className="bg-slate-800/50 rounded-lg p-4 mb-8">
                            <p className="text-xs text-slate-500 mb-1">Session ID</p>
                            <p className="text-sm text-slate-300 font-mono">{sessionId}</p>
                        </div>
                    )}

                    {/* Next Steps */}
                    <div className="bg-slate-800/30 rounded-2xl p-6 mb-8 text-left">
                        <h2 className="text-xl font-bold text-white mb-4">What's Next?</h2>
                        <ul className="space-y-3">
                            <li className="flex items-start gap-3">
                                <Zap className="w-5 h-5 text-orange-400 flex-shrink-0 mt-0.5" />
                                <span className="text-slate-300">Start calculating your cargo lashing requirements</span>
                            </li>
                            <li className="flex items-start gap-3">
                                <FileText className="w-5 h-5 text-orange-400 flex-shrink-0 mt-0.5" />
                                <span className="text-slate-300">Generate professional PDF reports with your company branding</span>
                            </li>
                            <li className="flex items-start gap-3">
                                <CheckCircle className="w-5 h-5 text-orange-400 flex-shrink-0 mt-0.5" />
                                <span className="text-slate-300">Check your subscription details and usage in your dashboard</span>
                            </li>
                        </ul>
                    </div>

                    {/* Actions */}
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <button
                            onClick={() => navigate('/calculator')}
                            className="px-8 py-4 bg-orange-600 hover:bg-orange-500 text-white rounded-xl font-bold transition-all shadow-lg shadow-orange-900/30 flex items-center justify-center gap-2"
                        >
                            Start Calculating
                            <ArrowRight className="w-5 h-5" />
                        </button>
                        <button
                            onClick={() => navigate('/subscription/manage')}
                            className="px-8 py-4 bg-slate-800 hover:bg-slate-700 text-white rounded-xl font-bold transition-all"
                        >
                            View Subscription
                        </button>
                    </div>

                    {/* Receipt Info */}
                    <p className="text-sm text-slate-500 mt-8">
                        A receipt has been sent to your email address.
                    </p>
                </div>
            </motion.div>
        </div>
    );
}

export default SubscriptionSuccess;
